import { Injectable } from "@angular/core"
import { Http, Headers, Response } from "@angular/http"
import { Observable } from "rxjs/Rx"


@Injectable()

export class HttpHelperService {
    constructor (
        private http: Http
    ) { }

    headers = function (auth: Boolean = false, token: String = '') {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Cache-Control", "no-store");
        headers.append("Pragma", "no-cache");
        if (auth) {
            headers.append("Authorization", "Bearer " + token);
        }
        return headers;
    }

    handleErrors(error: Response) {
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/helpers/http-helper.service.ts